import * as React from 'react';

import './styles/WizardFooter.scss';

type Props = {
  children: React.ReactNode;
};

export default function WizardFooter(props: Props) {
  return <footer className="WizardFooter">{props.children}</footer>;
}
